/* eslint-disable react-hooks/exhaustive-deps */
import { Alert } from '@mui/material'
import MatAppBar from '../MatAppBar/MatAppBar'
import { useState, useEffect } from 'react'
import { connect, useSelector } from 'react-redux'
import { makeStyles, createStyles } from '@mui/styles'
import { setShouldRender } from '../ProgressOverlay/store/actionCreator'
import CacheListManager from '../CacheListManager/CacheListManager'
import {
  api,
  INPUT_PERFORMANCE_DELAY,
  SCHEDULE_OR_ASSIGNMENT,
  WORK_ORDER_FILTER_PROPERTIES,
  WORK_ORDERS,
} from '../../globalConstants'
import { fetchData } from '../../service/HttpService'
import { setVendorWorkValidationWorkOrderList } from '../WorkOrderList/WorkOrderListStore/actionCreator'
import { setAssignments } from '../WorkOrderList/WorkOrderListStore/actionCreator'
import { useAuth } from '@praxis/component-auth'
import StatusAlert from '../StatusAlert/StatusAlert'
import CommonCardList from '../CommonCardList/CommonCardList'
import { filterAssignmentsBy7Days } from '../../utils'
import useSearch from '../../utils/hooks/useSearch'

const useStyles = makeStyles((theme) =>
  createStyles({
    cardHeader: {
      background: theme.palette.grey[300],
    },
    actionIcon: {
      margin: theme.spacing(1, 0.5, 0, 0),
    },
    cardContent: {
      padding: theme.spacing(1),
    },
    warningError: {
      margin: theme.spacing(1),
    },
  }),
)

const VendorWorkValidation = ({
  vendorWorkValidationWOs,
  setShouldRender,
  lastUpdated,
  storeId,
  setVendorWorkValidationWorkOrderList,
  setAssignments,
  toggle,
}) => {
  const URL_SEARCH_KEY = 'search'
  const classes = useStyles()
  const auth = useAuth()
  const userId = auth.session.userInfo.lanId?.toUpperCase()
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const { isDCUser } = useSelector((state) => ({
    ...state.userInfoReducer,
  }))

  const [filteredWorkOrders, onSearch] = useSearch(
    URL_SEARCH_KEY,
    vendorWorkValidationWOs || [],
    WORK_ORDER_FILTER_PROPERTIES(isDCUser),
    true,
    INPUT_PERFORMANCE_DELAY,
  )

  const vendorWorkValidationWOsLength = vendorWorkValidationWOs?.length

  useEffect(() => {
    const getOpenWorkOrders = async () => {
      if (!vendorWorkValidationWOsLength && !loading) {
        try {
          setShouldRender(
            true,
            `Loading...`,
            `Vendor Work Validation ${WORK_ORDERS}`,
          )
          setLoading(true)
          setError(false)
          const response = await fetchData(api.openWorkOrders(storeId))
          await setVendorWorkValidationWorkOrderList(response.woDetails)
        } catch (error) {
          setError(true)
        } finally {
          setLoading(false)
          setShouldRender(false)
        }
      }
    }
    getOpenWorkOrders()
  }, [vendorWorkValidationWOsLength])

  const infoMessage = `${filteredWorkOrders?.length} / ${vendorWorkValidationWOsLength} Work Validation WOs`

  const getAssignments = async () => {
    try {
      setShouldRender(true, 'Loading...', SCHEDULE_OR_ASSIGNMENT(isDCUser))
      const response = await fetchData(api.myAssignments(storeId, userId))
      const assigmentsScheduledThisWeek = filterAssignmentsBy7Days(
        response.assignmentsdata,
      )
      setAssignments(assigmentsScheduledThisWeek)
    } catch (error) {
      setError(true)
    } finally {
      setLoading(false)
      setShouldRender(false)
    }
  }

  useEffect(() => {
    return () => setVendorWorkValidationWorkOrderList([])
  }, [])

  useEffect(() => {
    vendorWorkValidationWOsLength && getAssignments()
  }, [toggle, vendorWorkValidationWOsLength])

  return (
    <>
      <MatAppBar
        arrowBack
        text="Work Validation"
        search={{
          onSearch: (input) => onSearch(input),
          searchKey: URL_SEARCH_KEY,
        }}
      />
      {!filteredWorkOrders?.length && !loading && !error && (
        <Alert
          severity="warning"
          data-testid={'no-data-text'}
          className={classes.warningError}
        >
          There are no work validation {WORK_ORDERS} to display.
        </Alert>
      )}

      {!loading && vendorWorkValidationWOsLength > 0 && (
        <CacheListManager
          lastUpdated={lastUpdated}
          listLength={vendorWorkValidationWOs}
          clearMethod={() => setVendorWorkValidationWorkOrderList([])}
        />
      )}
      {error && !loading && (
        <Alert severity="error" className={classes.warningError}>
          Unable to connect to {WORK_ORDERS} service.
        </Alert>
      )}

      {filteredWorkOrders && !loading ? (
        <>
          <StatusAlert text={infoMessage} />
          <CommonCardList
            listData={filteredWorkOrders}
            filteredWorkOrdersLength={vendorWorkValidationWOsLength}
          />
        </>
      ) : null}
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    vendorWorkValidationWOs: state.workOrderListReducer.vendorWorkValidationWOs,
    storeId: state.storeInfoReducer.storeId,
    lastUpdated: state.workOrderListReducer.lastUpdated.vendorWorkValidationWOs,
    toggle: state.workOrderListReducer.toggle,
  }
}

const mapDispatchToProps = {
  setShouldRender,
  setVendorWorkValidationWorkOrderList,
  setAssignments,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(VendorWorkValidation)
